module.exports = __webpack_public_path__ + "img/logo-500x100.ced359bb.png";